import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ReportsPartyWisePage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-reports-party-wise',
  templateUrl: 'reports-party-wise.html',
})
export class ReportsPartyWisePage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad ReportsPartyWisePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/reports-party-wise/reports-party-wise.ts